import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { ContinousBaseGesture } from "./gesture";
function changeEventCalculator(current, previous) {
    "worklet";
    var changePayload;
    if (previous === undefined) {
        changePayload = {
            changeX: current.translationX,
            changeY: current.translationY
        };
    } else {
        changePayload = {
            changeX: current.translationX - previous.translationX,
            changeY: current.translationY - previous.translationY
        };
    }
    return _object_spread({}, current, changePayload);
}
export var PanGesture = /*#__PURE__*/ function(ContinousBaseGesture) {
    "use strict";
    _inherits(PanGesture, ContinousBaseGesture);
    var _super = _create_super(PanGesture);
    function PanGesture() {
        _class_call_check(this, PanGesture);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "config", {});
        _this.handlerName = "PanGestureHandler";
        return _this;
    }
    _create_class(PanGesture, [
        {
            key: "activeOffsetY",
            value: function activeOffsetY(offset) {
                if (Array.isArray(offset)) {
                    this.config.activeOffsetYStart = offset[0];
                    this.config.activeOffsetYEnd = offset[1];
                } else if (offset < 0) {
                    this.config.activeOffsetYStart = offset;
                } else {
                    this.config.activeOffsetYEnd = offset;
                }
                return this;
            }
        },
        {
            key: "activeOffsetX",
            value: function activeOffsetX(offset) {
                if (Array.isArray(offset)) {
                    this.config.activeOffsetXStart = offset[0];
                    this.config.activeOffsetXEnd = offset[1];
                } else if (offset < 0) {
                    this.config.activeOffsetXStart = offset;
                } else {
                    this.config.activeOffsetXEnd = offset;
                }
                return this;
            }
        },
        {
            key: "failOffsetY",
            value: function failOffsetY(offset) {
                if (Array.isArray(offset)) {
                    this.config.failOffsetYStart = offset[0];
                    this.config.failOffsetYEnd = offset[1];
                } else if (offset < 0) {
                    this.config.failOffsetYStart = offset;
                } else {
                    this.config.failOffsetYEnd = offset;
                }
                return this;
            }
        },
        {
            key: "failOffsetX",
            value: function failOffsetX(offset) {
                if (Array.isArray(offset)) {
                    this.config.failOffsetXStart = offset[0];
                    this.config.failOffsetXEnd = offset[1];
                } else if (offset < 0) {
                    this.config.failOffsetXStart = offset;
                } else {
                    this.config.failOffsetXEnd = offset;
                }
                return this;
            }
        },
        {
            key: "minPointers",
            value: function minPointers(minPointers) {
                this.config.minPointers = minPointers;
                return this;
            }
        },
        {
            key: "maxPointers",
            value: function maxPointers(maxPointers) {
                this.config.maxPointers = maxPointers;
                return this;
            }
        },
        {
            key: "minDistance",
            value: function minDistance(distance) {
                this.config.minDist = distance;
                return this;
            }
        },
        {
            key: "minVelocity",
            value: function minVelocity(velocity) {
                this.config.minVelocity = velocity;
                return this;
            }
        },
        {
            key: "minVelocityX",
            value: function minVelocityX(velocity) {
                this.config.minVelocityX = velocity;
                return this;
            }
        },
        {
            key: "minVelocityY",
            value: function minVelocityY(velocity) {
                this.config.minVelocityY = velocity;
                return this;
            }
        },
        {
            key: "averageTouches",
            value: function averageTouches(value) {
                this.config.avgTouches = value;
                return this;
            }
        },
        {
            key: "enableTrackpadTwoFingerGesture",
            value: function enableTrackpadTwoFingerGesture(value) {
                this.config.enableTrackpadTwoFingerGesture = value;
                return this;
            }
        },
        {
            key: "activateAfterLongPress",
            value: function activateAfterLongPress(duration) {
                this.config.activateAfterLongPress = duration;
                return this;
            }
        },
        {
            key: "onChange",
            value: function onChange(callback) {
                // @ts-ignore TS being overprotective, PanGestureHandlerEventPayload is Record
                this.handlers.changeEventCalculator = changeEventCalculator;
                return _get(_get_prototype_of(PanGesture.prototype), "onChange", this).call(this, callback);
            }
        }
    ]);
    return PanGesture;
}(ContinousBaseGesture);
